module.exports = __webpack_public_path__ + "img/about-banner-lg.8a041006.jpg";